export default {
  walletTransactions: 'Wallet Transactions',
  date: 'Date',
  transactionTime: 'Transaction Time',
  nameLastname: 'Name Lastname',
  transactionType: 'Transaction Type',
  amount: 'Amount ($)',
  routeName: 'Route Name',
  campusArrival: 'Campus Arrival',
  campusDeparture: 'Campus Departure',
  boardingStop: 'Boarding Stop',
  campus: 'Campus',
  idNumber: 'ID Number',
  department: 'Department',
  transactionTypes: {
    TOPUP: 'Top-up',
    TOPUP_BY_ADMIN: 'Top-up By Admin',
    DEDUCT_BY_ADMIN: 'Deduct By Admin',
    SHUTTLE: 'Trip Pass',
    PASS_PACKAGE_PAYMENT: 'Pass Package Payment',
    SHUTTLE_PASS_PACKAGE: 'Trip Pass Package',
    PASS_PACKAGE_PURCHASE: 'Pass Package Purchase',
  },
  adjustWalletBalance: 'Adjust Wallet Balance',
  topUpWallet: 'Top Up Wallet',
  selectEnterAmount: 'Select/Enter Amount',
  enterAmount: 'Enter Amount',
  topUpAmount: 'Select Amount',
  topUpSuccess: 'Top-up successful for {0} rider(s).',
  topUpPartialSuccess: 'Top-up successful for {0} rider(s). Failed for {1} rider(s).',
  topUpFailed: 'Top-up failed for all selected riders.',
  topUp: 'Top Up',
  add: 'Add',
  deduct: 'Deduct',
  notes: 'Notes',
  addNotes: 'Add notes',
  amountRange: 'Amount must be between {0} and {1}',
  topUpsByRiders: 'Top-ups by Riders',
  topUpsByAdmins: 'Top-ups by Admins',
  tripPasses: 'Trip Passes',
  passPackagePurchase: 'Pass Package Purchase',
};
